module.exports = __webpack_public_path__ + "img/ic_image2.006e211d.svg";